import type { ReactNode, SVGProps } from "react";
import type { AriaButtonOptions } from "react-aria";

import { cssFns } from "../css";
import {
  DesktopArrowDown,
  DesktopArrowUp,
  LineCloseCircle,
  LineCloseIcon,
} from "../icons";
import { colors } from "../theme";

export const ButtonIcon = ({
  icon,
  onPress,
}: {
  icon: ReactNode;
  onPress?: () => void;
}) => {
  return (
    <div
      css={[cssFns.center, { zIndex: 10 }]}
      onPointerDown={(e) => {
        if (onPress) {
          e.stopPropagation();
          onPress();
        }
      }}
    >
      {icon}
    </div>
  );
};

export const ClearIcon = ({
  onPress,
  variant = "circled",
}: {
  onPress?: () => void;
  variant: "transparent" | "circled";
}) => {
  return (
    <ButtonIcon
      icon={
        variant === "circled" ? (
          <LineCloseCircle color={colors.principal.gs8} />
        ) : (
          <LineCloseIcon
            color={colors.principal.white}
            width={20}
            height={20}
          />
        )
      }
      onPress={onPress}
    />
  );
};

export const DropdownIcon = ({
  state,
  triggerProps,
  onPress,
}: {
  state?: boolean;
  triggerProps?: AriaButtonOptions<"button">;
  onPress?: () => void;
}) => {
  const icon =
    typeof state !== "undefined" ? (
      state ? (
        <DesktopArrowUp />
      ) : (
        <DesktopArrowDown />
      )
    ) : triggerProps?.["aria-expanded"] ? (
      <DesktopArrowUp />
    ) : (
      <DesktopArrowDown />
    );

  return <ButtonIcon icon={icon} onPress={onPress} />;
};

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.46967 5.46967C2.76256 5.17678 3.23744 5.17678 3.53033 5.46967L8 9.93934L12.4697 5.46967C12.7626 5.17678 13.2374 5.17678 13.5303 5.46967C13.8232 5.76256 13.8232 6.23744 13.5303 6.53033L8.53033 11.5303C8.23744 11.8232 7.76256 11.8232 7.46967 11.5303L2.46967 6.53033C2.17678 6.23744 2.17678 5.76256 2.46967 5.46967Z"
      fill="white"
    />
  </svg>
);

export const ArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.46967 10.5303C2.76256 10.8232 3.23744 10.8232 3.53033 10.5303L8 6.06066L12.4697 10.5303C12.7626 10.8232 13.2374 10.8232 13.5303 10.5303C13.8232 10.2374 13.8232 9.76256 13.5303 9.46967L8.53033 4.46967C8.23744 4.17678 7.76256 4.17678 7.46967 4.46967L2.46967 9.46967C2.17678 9.76256 2.17678 10.2374 2.46967 10.5303Z"
        fill="white"
      />
    </g>
  </svg>
);
